/**
 * cleanLocation — strip zip codes and country codes from a raw location
 * string for the v2 job card display. Scoped to /v2; do NOT promote to a
 * shared util without product approval (legacy data is intentionally
 * preserved elsewhere — see "Location Data Cleaning" memory).
 *
 * Examples:
 *   "Wichita Falls, Texas, 76302, US" -> "Wichita Falls, Texas"
 *   "Chicago, IL, US"                 -> "Chicago, IL"
 *   "Remote"                          -> "Remote"
 *   "London, UK"                      -> "London"
 */
const COUNTRY_RE =
  /^(us|usa|u\.s\.|u\.s\.a\.|united states|united states of america|uk|u\.k\.|united kingdom|ca|canada)$/i;

const isZipLike = (s: string): boolean => {
  if (/^[\d\-\s]+$/.test(s)) return true; // 76302, 90210-1234
  if (/^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i.test(s)) return true; // Canadian postal
  if (/^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i.test(s)) return true; // UK postcode
  return false;
};

export const cleanLocation = (raw?: string | null): string => {
  if (!raw) return "";
  const trimmed = raw.trim();
  if (!trimmed) return "";
  if (/^remote$/i.test(trimmed)) return "Remote";

  const parts = trimmed
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean)
    .filter((p) => !COUNTRY_RE.test(p) && !isZipLike(p));

  if (parts.length === 0) return trimmed;
  return parts.slice(0, 2).join(", ");
};

export default cleanLocation;
